module.exports = __webpack_public_path__ + "static/media/bread-loaf.053f3fa2.svg";